module.exports = __webpack_public_path__ + "img/bid-open-hall-left.d2637a42.png";